import tippy from "tippy.js";
import { initIntersectionObserver } from "@plugins";

const warrantyLabels = document.querySelectorAll(".js-card-info-labels__warranty");

if (warrantyLabels && warrantyLabels.length) {
    for (const label of warrantyLabels) {
        initIntersectionObserver(label, initWarrantyLabelTooltip);
    }
}

function initWarrantyLabelTooltip(label) {
    tippy(label, {
        arrow: true,
        placement: "top",
        maxWidth: 220,
        interactive: true,
        allowHTML: true,
        hideOnClick: true,
        theme: "light",
        appendTo: () => document.body,
        trigger: "mouseenter click",
        content: label.querySelector(".js-card-info-labels__warranty-tooltip"),
    });
}
